import { render } from "./FormTour.vue?vue&type=template&id=7cf4f742"
import script from "./FormTour.vue?vue&type=script&lang=js"
export * from "./FormTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__